var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBeta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 14,
    viewBox: "0 0 29 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 2.23858 2.23858 0 5 0H29V9C29 11.7614 26.7614 14 24 14H0V5Z",
    fill: "#CF1322"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10V4H5.37862C6.20258 4 6.82755 4.14011 7.25352 4.42033C7.6795 4.6978 7.89249 5.10577 7.89249 5.64423C7.89249 5.93819 7.80698 6.1978 7.63597 6.42308C7.46496 6.6456 7.2271 6.80907 6.92238 6.91346C7.27063 6.99038 7.54424 7.1456 7.74324 7.37912C7.94534 7.61264 8.0464 7.89835 8.0464 8.23626C8.0464 8.81319 7.83807 9.25 7.42143 9.5467C7.00478 9.84341 6.4109 9.99451 5.6398 10H3ZM4.39919 7.38736V9.00687H5.59782C5.92741 9.00687 6.18392 8.93819 6.36737 8.80082C6.55393 8.66071 6.64721 8.46841 6.64721 8.2239C6.64721 7.67445 6.3254 7.3956 5.68177 7.38736H4.39919ZM4.39919 6.51374H5.43458C6.14039 6.50275 6.4933 6.25412 6.4933 5.76786C6.4933 5.49588 6.40313 5.30082 6.22279 5.18269C6.04556 5.06181 5.76417 5.00137 5.37862 5.00137H4.39919V6.51374Z",
    fill: "#F5F6F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2816 7.39973H10.5952V9.00687H13.748V10H9.19597V4H13.7387V5.00137H10.5952V6.43132H13.2816V7.39973Z",
    fill: "#F5F6F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8693 5.00137H17.7892V10H16.39V5.00137H14.3379V4H19.8693V5.00137Z",
    fill: "#F5F6F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0411 8.76374H21.5879L21.1215 10H19.6337L22.1616 4H23.4581L26 10H24.5122L24.0411 8.76374ZM21.9657 7.76236H23.6634L22.8099 5.51648L21.9657 7.76236Z",
    fill: "#F5F6F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBeta);
export default __webpack_public_path__ + "static/media/icon-beta.48e239f2e81ffa1cf505cce06669eb52.svg";
export { ForwardRef as ReactComponent };